<template>
  <div class="hello" style="background-color:#f4f5f5; height:100%">
    <van-sticky class="item-pop">
      <div style="position: relative; max-width: 640px; left:auto; margin: 0 auto;">
        <van-nav-bar style="height:40px;background: rgb(53, 120, 229)" :border="false" @click-left="goback" safe-area-inset-top>
          <template #left>
            <van-icon style=" font-weight: 900;" name="arrow-left" color="#FFFFFF" size="25"/>
          </template>
          <template #title>
            <span style="color:#FFFFFF; font-weight: 700; font-size: 19px;">商品分類</span>
          </template>
        </van-nav-bar>
      </div>
    </van-sticky>
    <van-tree-select
      style="padding-bottom: 80px;"
      height="100vh"
      v-if="items.length > 0"
      :items="items"
      :active-id.sync="activeId"
      :main-active-index.sync="activeIndex"
      @click-item="gotolist"
    />
  </div>
</template>
<script>
import { getCategoryList } from '@/api/category'
import { Toast } from 'vant'

export default {
  name: '',
  data () {
    return {
      items: [],
      activeId: 1,
      activeIndex: 0
    }
  },
  watch: {

  },
  created () {
    this.getCategory()
  },
  methods: {
    goback () {
      this.$router.back(-1)
      window.scrollTo(0, 0)
    },
    getCategory () {
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 3000
      })
      getCategoryList().then(res => {
        if (res.code === 200) {
          this.items = []
          this.items = res.data
          Toast.clear()
        } else {
          Toast.fail('加載出錯，請刷新重試')
        }
      })
    },
    gotolist (e) {
      this.$router.push({path: '/list', query: { index: this.items[this.activeIndex].text, label: e.text }})
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.van-sidebar-item--select::before {
  background-color: rgb(53, 120, 229);
}
.van-tree-select__item--active {
  color: rgb(53, 120, 229);
}
</style>



// WEBPACK FOOTER //
// src/components/Category.vue